import { render, staticRenderFns } from "./member-card.vue?vue&type=template&id=516c6314&scoped=true"
import script from "./member-card.vue?vue&type=script&lang=js"
export * from "./member-card.vue?vue&type=script&lang=js"
import style0 from "./member-card.vue?vue&type=style&index=0&id=516c6314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c6314",
  null
  
)

export default component.exports